<script setup>
defineProps({
  item: {
    type: String,
    default: "",
  },
});
function camelToNormal(text) {
  return `${text.slice(0, 1)}${text.slice(1).toLowerCase()}`;
}
import ArgonBadge from "./../ArgonBadge";
</script>
<template>
  <argon-badge :color="'secondary'" class="size no-uppercase">{{
    camelToNormal(item)
  }}</argon-badge>
</template>

<style scoped>
.size {
  min-width: 160px;
  padding: 0.45em 0.8em !important;
}

.no-uppercase {
  text-transform: capitalize !important;
}
</style>
